<template>
  <div class="roomie-input-label">
    <label
      class="roomie-input-label__title"
      :for="id">{{ label }}
      <span
        v-if="required"
        class="roomie-input-label__require-mark">
        *
      </span>
    </label>
    <slot name="after-label" />
  </div>
</template>

<script>
export default {
  name: 'RoomieInputLabel',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style src='./_index.scss' lang='scss'/>
